export const FinancialReportFilter = {
  MonthRange: "monthRange" as const,
  ComparisonColumns: "comparisonColumns" as const,
  Dimensions: "dimensions" as const,
  DimensionTypeId: "dimensionTypeId" as const,
  DimensionType: "dimensionType" as const,
  SecondDimensionTypes: "secondDimensionTypes" as const,
  OnlyDimensionsWithTransactions: "onlyDimensionsWithTransactions" as const,
  OnlyActiveDimensions: "onlyActiveDimensions" as const,
  ShowAccountNumber: "showAccountNumber" as const,
  HideAverageMonthAndDifference: "hideAverageMonthAndDifference" as const,
  ExpandAllRows: "expandAllRows" as const,
}

export const CompanyBooksReportFilter = {
  BookingDate: "bookingDate" as const,
  Account: "account" as const,
  Amount: "amount" as const,
  VoucherNumber: "voucherNumber" as const,
  Series: "series" as const,
  Dimensions: "dimensions" as const,
  CategoryId: "categoryId" as const,
  Category: "category" as const,
  AccountNumbers: "accountNumbers" as const,
  IsAudit: "isAudit" as const,
}

export const FinancialReportDateFilter = {
  Dimensions: "dimensions" as const,
  Columns: "columns" as const,
}

export const FinancialReportColumnFilter = {
  Selection: "selection" as const,
  Range: "range" as const,
}

export const ReconciliationReportFilter = {
  ReconciliationId: "reconciliationId" as const,
  Reconciliation: "reconciliation" as const,
}

